<template>
    <div class="profile-box flex px-1 justify-content-start w-auto">
        <app-avatar :title="employee.full_name"
                    :status="employee.status"
                    avatar-class="avatars-w-30 d-inline-block"
                    :img="$optional(employee, 'profile_picture', 'full_url')"
        />

        <div class="flex-grow-1 flex-shrink-0">
            <div class="employee-name">
                <a :href="`/employees/${employee.id}/profile`" target="_blank" class="employee-link">
                    <span v-if="$optional(employee, 'profile', 'employee_id')" class="employee-id-text">{{ employee.profile.employee_id }} </span>{{ employee.full_name }}
                </a>
            </div>
            <div class="employee-subtitle d-flex align-items-center">
                <p class="department-text mb-0 mr-2">{{ $optional(employee, 'department', 'name') }}</p>
                <app-note-editor
                    v-if="$optional(employee, 'profile')"
                    :id="employee.id"
                    :row-data="employee"
                    :note-title="$t('shift_note')"
                    :note-description="$optional(employee, 'profile', 'shift_note')"
                    :url="`app/employees/${employee.id}/shift-note`"
                    icon-class="size-14"
                    @note-submitted="(note) => employee.profile.shift_note = note"
                />
            </div>
        </div>

        <template v-if="employeeActionBtn.show">
            <button 
                v-if="!employeeActionBtn.class.includes('disabled')" 
                class="btn btn-sm rounded-circle p-1 btn-success-soft"
                @click="employeeActionBtn.action"
                :title="employeeActionBtn.title"
            >
                <app-icon name="check-circle" class="size-16 text-primary"/>
            </button>
            <span v-else class="text-success">
                <app-icon name="check-circle" class="size-16 text-primary"/>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    name: "AppEmployeeProfileCardHorizontal",
    props: {
        employee: {},
        employeeActionBtn: {
            show: false,
            title: '',
            class: '',
            action: '',
        },
    }
}
</script>

<style scoped lang="scss">
.profile-box {
    flex-direction: row !important;
    gap: 8px;
    align-items: center;
}

.employee-name {
    margin: 0;
    font-size: 0.82rem;
    font-weight: 500;
    line-height: 1.1;
    margin-top: 8px;
}

.employee-link {
    color: var(--default-font-color);
    font-weight: inherit;
}

.employee-id-text {
    font-size: inherit;
    font-weight: inherit;
}

.employee-subtitle {
    margin-top: -4px;
}

.department-text {
    margin: 0;
    color: #8a94a6;
    font-size: 0.7rem;
    line-height: 1;
}
</style>
